import BaseService from "../base.service";
import http from "../../http-common";
class Accounts extends BaseService {
  constructor() {
    super("accounts");
  }
  getAllAccounts(id) {
    return http.get(`${this.path}/${id}`);
  }
  insert(data) {
    return http.post(`${this.path}/`, data);
  }
  updateById(data) {
    return http.put(`${this.path}/${data._id}`, data);
  }
  deleteById(_id) {
    return http.delete(`${this.path}/${_id}`);
  }

 
}

export default new Accounts();